import React from "react";
import NarrativeAssessmentLineViewer from "./NarrativeAssessmentLineViewer";
import GoogleSearchConsoleNarrativeAssessmentViewer from "./GoogleSearchConsoleNarrativeAssessmentViewer";
import GoogleMerchantCenterNarrativeAssessmentViewer from "./GoogleMerchantCenterNarrativeAssessmentViewer";
import BenchmarkNarrativeAssessmentViewer from "./BenchmarkNarrativeAssessmentViewer";
import MetaNarrativeAssessmentViewer from "./MetaNarrativeAssessmentViewer";
import MarketAnalysisNarrativeAssessmentViewer from "./MarketAnalysisNarrativeAssessmentViewer";
import TargetAudienceNarrativeAssessmentViewer from "./TargetAudienceNarrativeAssessmentViewer";
import CompetitorAnalysisNarrativeAssessmentViewer from "./CompetitorAnalysisNarrativeAssessmentViewer";
import ContentCalendarNarrativeAssessmentViewer from "./ContentCalendarNarrativeAssessmentViewer";
import {
  parseNarrativeAssessmentLine,
  normalizeNarrativeAssessmentTitle,
} from "./narrativeAssessmentLineUtils";

const FoundationNarrativeAssessmentLineRenderer = ({ markdown = "" }) => {
  const parsed = parseNarrativeAssessmentLine(markdown);
  if (!parsed) return null;

  const t = normalizeNarrativeAssessmentTitle(parsed.title);

  if (t.includes("google search console assessment")) {
    return <GoogleSearchConsoleNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("google merchant center assessment")) {
    return <GoogleMerchantCenterNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("benchmark assessment")) {
    return <BenchmarkNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("meta report assessment")) {
    return <MetaNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("market analysis assessment")) {
    return <MarketAnalysisNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("target audience assessment")) {
    return <TargetAudienceNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("competitor analysis assessment")) {
    return <CompetitorAnalysisNarrativeAssessmentViewer markdown={markdown} />;
  }
  if (t.includes("content calendar assessment")) {
    return <ContentCalendarNarrativeAssessmentViewer markdown={markdown} />;
  }

  return <NarrativeAssessmentLineViewer markdown={markdown} />;
};

export default FoundationNarrativeAssessmentLineRenderer;
